import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner, Flex } from '@chakra-ui/react';
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { BottomControlTest } from '@src/components/sco/CardCarousel/Controls/BottomControlTest';
import { VideoHeroCard } from '@src/components/sco/Education/VideoLanding/VideoHeroCard';
import { gql, gqlArgs, gqlVars } from '@src/lib/gql';
import React from 'react';
type VideoHeroProps = {
  keywords?: string;
  termSlugs?: string[];
  carouselProps?: CardCarouselProps;
};
export const VideoHero = props => {
  const $ = _c(16);
  let t0;
  if ($[0] !== props) {
    t0 = VideoHero.queries.videoLists(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.keywords || $[3] !== props.termSlugs) {
    t1 = {
      variables: {
        termSlugs: props.termSlugs,
        keywords: props.keywords
      }
    };
    $[2] = props.keywords;
    $[3] = props.termSlugs;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[5] !== query.loading) {
    t2 = query.loading && <Center aspectRatio={2} padding="1em" width="full"><Spinner /></Center>;
    $[5] = query.loading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== query.error) {
    t3 = query.error && <p>{"Error: "}{query.error.message}</p>;
    $[7] = query.error;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props.carouselProps || $[10] !== query.data) {
    t4 = query.data && <CardCarousel fade={false} visibleCards={[1]} controls={{
      top: false,
      bottom: BottomControlTest
    }} {...props.carouselProps}>{query.data.videoLists.map(_temp)}</CardCarousel>;
    $[9] = props.carouselProps;
    $[10] = query.data;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <Flex align="flex-start" bgImage="linear-gradient(transparent, {colors.colorPalette.muted/50})" boxShadow="inset 0px -20px 10px -20px rgba(0, 0, 0, 0.15)" justify="center" position="relative" width="full">{t2}{t3}{t4}</Flex>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
VideoHero.fragments = {
  VideoList: () => gql`
    fragment _ on VideoList {
      id
      slug
      featuredImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 1000 } } })
      }
      shortDescription
      longDescription
      people {
        id
        firstName
        lastName
        title
        companyName
        companyLogo {
          id
          url
        }
        avatar {
          id
          url
        }
      }
      videos {
        id
        slug
        featuredImage {
          id
          url
        }
        videoPreviewUrl
      }
      title
      terms {
        id
        name
        slug
      }
    }
  `
};
VideoHero.queries = {
  videoLists: (props: VideoHeroProps) => {
    const vars = gqlVars({
      '$keywords: String': props.keywords,
      '$termSlugs: [String]': props.termSlugs?.length > 0
    });
    const where = gqlArgs({
      'where: ': {
        '_search: $keywords': props.keywords,
        'terms_some: { slug_in: $termSlugs }': props.termSlugs?.length > 0
      }
    });
    return gql`
      query ${vars} {
        videoLists(
          orderBy: publishedAt_DESC
          first: 5
          ${where}
        ) {
          ${VideoHero.fragments.VideoList()}
        }
      }
    `;
  }
};
function _temp(videoList) {
  return <VideoHeroCard key={videoList.id} avatar={videoList.people[0].avatar?.url} companyLogoUrl={videoList.people[0].companyLogo?.url} firstName={videoList.people[0].firstName} image={videoList.featuredImage?.url} lastName={videoList.people[0].lastName} slug={videoList.slug} stepSlug={videoList.videos[0]?.slug} title={videoList.title} url={`/videos/${videoList.slug}/${videoList.videos[0]?.slug}?play=1`} video={videoList.videos[0]?.videoPreviewUrl} videoPreviewUrl={videoList.videos[0]?.videoPreviewUrl} />;
}